import {
  HEALTH_IMPACT,
  WELLBEING_IMPACT,
  INDIRECT_FINANCIAL_HEALTH_IMPACT,
  INDIRECT_FINANCIAL_HUMAN_CAPITAL_IMPACT
} from '../fields'

// Chart mode constants
export const chartModes = {
  total: 'total',
  byImpactPathway: 'byImpactPathway'
}

// Tab options for the chart mode
export const tabOptions = [
  { value: chartModes.total, label: 'Total' },
  { value: chartModes.byImpactPathway, label: 'By Impact Pathway' }
]

export const impactTypes = {
  [HEALTH_IMPACT]: HEALTH_IMPACT,
  [WELLBEING_IMPACT]: WELLBEING_IMPACT,
  [INDIRECT_FINANCIAL_HEALTH_IMPACT]: INDIRECT_FINANCIAL_HEALTH_IMPACT,
  [INDIRECT_FINANCIAL_HUMAN_CAPITAL_IMPACT]: INDIRECT_FINANCIAL_HUMAN_CAPITAL_IMPACT
}

export const impactColors = {
  [INDIRECT_FINANCIAL_HEALTH_IMPACT]: '#D08B67',
  [INDIRECT_FINANCIAL_HUMAN_CAPITAL_IMPACT]: '#E2C6AA',
  [WELLBEING_IMPACT]: '#880055',
  [HEALTH_IMPACT]: '#402022'
}
